import React, { useEffect } from 'react'
import {Helmet}from"react-helmet";
import '../components/Styles/blog1.css'
import '../components/Styles/about.css'
import blog3 from '../assets/images/blg23-min.png';

import AOS from 'aos';
import 'aos/dist/aos.css';
import Blogina from './Blogina';


const Sipc = () => {
    useEffect(()=>{
        AOS.init();
       
      })
    
  return (
    <div>
                 <Helmet>
      
      <title>33% Fund — Custody & SIPC Protection</title>
      <meta name="description" content="Value Investing: The Time to Buy is When There’s Blood on the Streets"/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>

        <section className='about__us_main' >
          <h1 data-aos="zoom-in">33% Fund — Custody & SIPC Protection</h1>
       
          
         </section>

<br /><br /><br />
      <section className='blog_sub_sec'>
      <div >
         <h2>Custody of Assets</h2>
         <p>33% Fund (“the Fund”) utilizes a U.S.-regulated, SIPC-member broker-dealer as its custodian and execution partner.
All assets are held in accordance with U.S. regulatory requirements governing customer segregation and broker-dealer capital standards.
<br/><br/>
The Fund does not directly custody investor assets. Cash and securities remain at the custodian in segregated accounts under the custodian’s regulatory framework.
<br/><br/>
<b>SIPC Protection Overview</b>
<br/>
The Fund’s custodian is a member of the Securities Investor Protection Corporation (SIPC). SIPC protection applies only if a SIPC-member broker-dealer fails financially and customer assets are missing.
<br/>
SIPC provides protection up to:<br/>
. $500,000 per customer, including<br/>
. $250,000 for cash awaiting reinvestment.<br/><br/>

Under SIPC rules, “securities” generally include:<br/>
Equities<br/>
. Fixed income instruments<br/>
. Exchange-traded funds (ETFs)<br/>
. Options<br/>
. Mutual funds<br/>
. Money market funds<br/>
. Other registered securities
<br/><br/>
SIPC’s mandate is to restore custody of client assets, not to insure investment performance.
<br/><br/>
<b>What SIPC Does Not Cover</b><br/>
. SIPC does not insure or protect against:<br/>
. Losses resulting from market fluctuations<br/>
. The performance of any investment strategy<br/>
. Trading losses, volatility, or drawdowns<br/>
. Unregistered securities<br/>
. Crypto assets<br/>
. Commodities and futures positions<br/>
. Counterparty performance outside of broker insolvency
<br/><br/>

SIPC is not equivalent to FDIC insurance. It does not guarantee or stabilize asset value.
<br/><br/>
<b>How Protection Works in the Event of Broker Failure</b><br/>
1. If a SIPC-member broker-dealer fails:<br/>
2. SIPC appoints a trustee to oversee the recovery process.<br/>
3. The trustee works to return customer cash and securities.<br/>
4. SIPC protection applies up to statutory limits.<br/>
5. Investors generally receive their securities in kind, not cash equivalents.
<br/><br/>
This process is designed to restore custodial positions, not protect investment returns.
<br/><br/>
<b>Regulatory Disclosure</b><br/>
SIPC protection is provided by the custodian broker-dealer, not by 33% Fund. The Fund does not provide SIPC insurance, guarantees, or assurances against investment loss.<br/>
This information is provided for general purposes only. It does not constitute an offer to sell or a solicitation to buy any security. Any offering of interests in 33% Fund is made exclusively through formal offering documents provided to qualified investors.
</p>
        </div>
      
      </section>
    </div>
  )
}

export default Sipc;